import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
import { Eyebrow, SectionTitle } from './ui/Section';
const collapseTransition = {
  duration: 0.22,
  ease: [0.23, 1, 0.32, 1] as const
};
export function Faq() {
  const [open, setOpen] = useState(0);
  return <section className="bg-canvas px-4 py-12 md:py-16" data-id="element-53" data-mp="1gauq77h1rshc">
      <div className="mx-auto max-w-3xl" data-id="element-54" data-mp="2dz4vpwg1kyd7">
        <Eyebrow data-id="element-55" data-mp="2dy3iblbjzzsb">What people usually ask</Eyebrow>
        <SectionTitle data-id="element-56" data-mp="292eh7djvyatw">Frequently asked questions</SectionTitle>
        <div className="mt-8 space-y-3" data-id="element-57" data-mp="24206fnqwgms6">
          {faqs.map(([question, answer], index) => <div key={question} className={`overflow-hidden rounded-2xl border bg-white transition-colors duration-150 ease-out ${open === index ? 'border-brand shadow-md' : 'border-navy/10'}`} data-id="element-58" data-mp="1z370qhhuu02k" data-mpi={index}>
              <button className="flex w-full items-center justify-between gap-3 p-4 text-left font-display text-xs font-extrabold uppercase text-navy md:text-sm" onClick={() => setOpen(open === index ? -1 : index)} aria-expanded={open === index} data-id="element-59" data-mp="nmyv2774m8mo">
                {question}
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} data-id="element-60" data-mp="flunvi0degrn" />
              </button>
              <AnimatePresence initial={false} data-id="element-61" data-mp="bi6gp0fnhn6x">
                {open === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={collapseTransition} className="border-t border-navy/10 px-4 py-3 text-sm leading-relaxed text-steel" data-id="element-62" data-mp="bk9dc3bb6ekm">
                    {answer}
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}